/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import {
  Check,
  RefreshCw,
  Info,
  Truck,
  Package,
  Clock,
  MapPin,
  X,
  DollarSign,
  Zap,
  Eye,
  EyeOff,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { applyStoreDraft } from "../../redux/store/store";

export default function ActivationGuepex() {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);

  const isConnected =
    store.UserguidGuepex !== null &&
    store.UserguidGuepex !== "" &&
    store.UserguidGuepex !== false &&
    store.UserguidGuepex !== undefined &&
    store.Apitokenguepex !== null &&
    store.Apitokenguepex !== "" &&
    store.Apitokenguepex !== false &&
    store.Apitokenguepex !== undefined &&
    store.ApitokenGW !== null &&
    store.ApitokenGW !== "" &&
    store.ApitokenGW !== false &&
    store.ApitokenGW !== undefined;

  const [showGuid, setShowGuid] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [showTokenGW, setShowTokenGW] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const [data, setData] = useStoreFormDraft(store);

  // Configure SweetAlert to always appear on top
  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t("activationCompanies.alerts.confirmButton"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  if (!data.UserguidGuepex || !data.Apitokenguepex || !data.ApitokenGW) {
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation des données
    if (!data.UserguidGuepex || !data.Apitokenguepex || !data.ApitokenGW) {
      await showAlert(
        "warning",
        t("activationCompanies.alerts.missingData.title"),
        t("activationCompanies.alerts.missingData.text"),
      );
      return;
    }

    // Validation du type de livraison
    if (data.guepexeconomic === undefined) {
      await showAlert(
        "warning",
        t("activationCompanies.alerts.missingDeliveryType.title"),
        t("activationCompanies.alerts.missingDeliveryType.text"),
      );
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        "https://backend.foorweb.store/api/getLivraison",
        {
          params: {
            provider: "guepex",
            id: data.UserguidGuepex,
            token: data.Apitokenguepex,
          },
        },
      );

      // Si la réponse est ok, on poursuit le traitement
      if (response.status === 200) {
        setLoading(false);
        await saveStoreDraft(doc(db, "store", data.id), store, data);
        dispatch(applyStoreDraft(store, data));
        setData(data);
        await showAlert(
          "success",
          t("activationCompanies.alerts.activationSuccess.title"),
          "",
        );
      } else {
        setLoading(false);
        await showAlert(
          "error",
          t("activationCompanies.alerts.activationFailed.title"),
          t("activationCompanies.alerts.activationFailed.text"),
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'appel API", error);
      setLoading(false);
      await showAlert(
        "error",
        t("activationCompanies.alerts.activationError.title"),
        t("activationCompanies.alerts.activationError.text"),
      );
    }
  };

  const handleDeactivate = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: t("activationCompanies.alerts.deactivateConfirm.title"),
      text: t("activationCompanies.alerts.deactivateConfirm.text"),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.confirmText",
      ),
      cancelButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.cancelText",
      ),
      backdrop: `rgba(0,0,0,0.7)`,
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });

    if (result.isConfirmed) {
      try {
        const updatedData = { ...data };
        delete updatedData.UserguidGuepex;
        delete updatedData.Apitokenguepex;
        delete updatedData.ApitokenGW;
        delete updatedData.guepexeconomic;

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        dispatch(applyStoreDraft(store, updatedData));
        setData(updatedData);

        await Swal.fire({
          icon: "success",
          title: t("activationCompanies.alerts.deactivateSuccess.title"),
          text: t("activationCompanies.alerts.deactivateSuccess.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
          customClass: {
            popup: "swal-popup-on-top",
          },
        });
      } catch (error) {
        console.error("Error during deactivation:", error);
        await Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.deactivateError.title"),
          text: t("activationCompanies.alerts.deactivateError.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    }
  };

  const handleDeliveryTypeChange = (isEconomic) => {
    setData({ ...data, guepexeconomic: isEconomic });
  };

  return (
    <div className="min-h-[400px] max-h-[calc(100vh-180px)] overflow-y-auto p-6 dark:!bg-[#181819] dark:!text-gray-200">
      <h3 className="text-lg font-semibold text-[#9e68ba] mb-3">
        {t("activationCompanies.guepex.title")}
      </h3>
      <Form onSubmit={handleSubmit}>
        <div className="mb-4">
          <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
            {t("activationCompanies.guepex.accountIdLabel")}
          </p>
          <Form.Group className="mb-3">
            <div className="relative mb-3">
              <Form.Control
                type={showGuid ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.guepex.accountIdPlaceholder1",
                )}
                value={data.UserguidGuepex || ""}
                onChange={(e) =>
                  setData({ ...data, UserguidGuepex: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500 
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200 
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowGuid(!showGuid)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showGuid ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <div className="relative mb-3">
              <Form.Control
                type={showToken ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.guepex.accountIdPlaceholder2",
                )}
                value={data.Apitokenguepex || ""}
                onChange={(e) =>
                  setData({ ...data, Apitokenguepex: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500 
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200 
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowToken(!showToken)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showToken ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <div className="relative mb-3">
              <Form.Control
                type={showTokenGW ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.guepex.accountIdPlaceholder3",
                )}
                value={data.ApitokenGW || ""}
                onChange={(e) =>
                  setData({ ...data, ApitokenGW: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500 
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200 
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowTokenGW(!showTokenGW)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showTokenGW ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <Form.Text className="text-muted dark:!text-gray-400">
              {t("activationCompanies.guepex.accountIdHint")}
            </Form.Text>
          </Form.Group>
        </div>

        {/* Delivery Type Selection */}
        <div className="mb-6">
          <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
            {t("activationCompanies.guepex.deliveryTypeLabel")}
          </p>
          <div className="flex flex-col md:flex-row gap-4">
            <div
              className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                data.guepexeconomic === true
                  ? "border-[#9e68ba] bg-[#f9f3ff] dark:!bg-[#1f1a25]"
                  : "border-gray-300 dark:!border-[#3c3a3d] hover:border-[#9e68ba]/50"
              }`}
              onClick={() => handleDeliveryTypeChange(true)}
            >
              <div className="flex items-center mb-2">
                <div
                  className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                    data.guepexeconomic === true
                      ? "border-[#9e68ba] bg-[#9e68ba]"
                      : "border-gray-400 dark:!border-gray-600"
                  }`}
                >
                  {data.guepexeconomic === true && (
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  )}
                </div>
                <DollarSign size={20} className="text-[#9e68ba] mr-2" />
                <span className="font-medium text-gray-800 dark:!text-gray-200">
                  {t("activationCompanies.guepex.deliveryTypes.economic")}
                </span>
              </div>
              <p className="text-sm text-gray-600 dark:!text-gray-400 mr-8">
                {t(
                  "activationCompanies.guepex.deliveryTypes.economicDescription",
                )}
              </p>
            </div>

            <div
              className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                data.guepexeconomic === false
                  ? "border-[#9e68ba] bg-[#f9f3ff] dark:!bg-[#1f1a25]"
                  : "border-gray-300 dark:!border-[#3c3a3d] hover:border-[#9e68ba]/50"
              }`}
              onClick={() => handleDeliveryTypeChange(false)}
            >
              <div className="flex items-center mb-2">
                <div
                  className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                    data.guepexeconomic === false
                      ? "border-[#9e68ba] bg-[#9e68ba]"
                      : "border-gray-400 dark:!border-gray-600"
                  }`}
                >
                  {data.guepexeconomic === false && (
                    <div className="w-2 h-2 rounded-full bg-white"></div>
                  )}
                </div>
                <Zap size={20} className="text-[#9e68ba] mr-2" />
                <span className="font-medium text-gray-800 dark:!text-gray-200">
                  {t("activationCompanies.guepex.deliveryTypes.express")}
                </span>
              </div>
              <p className="text-sm text-gray-600 dark:!text-gray-400 mr-8">
                {t(
                  "activationCompanies.guepex.deliveryTypes.expressDescription",
                )}
              </p>
            </div>
          </div>
        </div>

        {/* Tips Section */}
        <div
          className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4 
                    dark:!bg-[#181919] dark:!border-[#3c3a3d]"
        >
          <h4 className="font-medium text-xl text-[#9e68ba] mb-2 d-flex align-items-center">
            <Info size={18} className="ml-2" />
            {t("activationCompanies.guepex.tipsTitle")}
          </h4>
          <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
            <li className="d-flex align-items-start mb-2">
              <Truck
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.guepex.tips.delivery")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Package
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.guepex.tips.packaging")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Clock
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.guepex.tips.timing")}</span>
            </li>
            <li className="d-flex align-items-start">
              <MapPin
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.guepex.tips.accuracy")}</span>
            </li>
          </ul>
        </div>

        <div className="d-flex justify-content-between mt-4">
          {!isConnected ? (
            <Button
              type="submit"
              disabled={loading}
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "rgb(141, 93, 167)",
                borderColor: "rgb(141, 93, 167)",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("activationCompanies.guepex.activating")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("activationCompanies.guepex.activate")}
                </>
              )}
            </Button>
          ) : (
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDeactivate}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("activationCompanies.guepex.deactivate")}
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}
